// Busca de cliente no cadastro por nome ou CPF/CNPJ, usada na Agenda (campo "Cliente" do lembrete).
// Mesma ideia da busca do Truck Control, com os endpoints do Nexus CRVA:
//
// GET /clientes/cpf/{11 dígitos}   -> cliente | null
// GET /clientes/cnpj/{14 dígitos}  -> cliente | null
// GET /clientes/nome/{texto}       -> [clientes] | 204   (o back compara em minúsculas)
//
// O back procura o nome pelo texto inteiro ("claudia braga" não acharia "CLAUDIA DE AVILA BRAGA"): busca pela maior
// palavra e confere as demais aqui.
import axios from 'axios';
import config from '../config/config';

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` } });

const semAcento = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

// Palavras do nome digitado; vazio quando nenhuma tem 3 letras (busca curta demais)
export function palavrasDoNome(nome) {
  const palavras = String(nome || '').toLowerCase().split(/\s+/).filter(Boolean);
  return palavras.some((p) => p.length >= 3) ? palavras : [];
}

// Todas as palavras aparecem no nome, em qualquer ordem, sem diferenciar acento nem maiúscula
export function nomeConfere(nomeCliente, palavras) {
  const nome = semAcento(nomeCliente);
  return palavras.every((p) => nome.includes(semAcento(p)));
}

// CPF/CNPJ formatado para exibir na lista de resultados
export function documentoDoCliente(cliente) {
  const digitos = String(cliente?.cpf || cliente?.cnpj || '').replace(/\D/g, '');
  if (digitos.length === 11) return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  if (digitos.length === 14) return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  return cliente?.cpf || cliente?.cnpj || '';
}

// Um campo só (nome OU CPF/CNPJ). Documento: só CPF (11) ou CNPJ (14) completo.
// null = nada para buscar (nome com menos de 3 letras ou documento incompleto).
export async function buscarClientesPorTermo(termo) {
  const { API_BASE_URL } = config;
  const texto = String(termo || '').trim();

  if (/^[\d.\-/\s]+$/.test(texto)) {
    const digitos = texto.replace(/\D/g, '');
    if (digitos.length !== 11 && digitos.length !== 14) return null;
    const tipo = digitos.length === 11 ? 'cpf' : 'cnpj';
    try {
      const { data } = await axios.get(`${API_BASE_URL}/clientes/${tipo}/${digitos}`, auth());
      return data ? [data] : [];
    } catch (error) {
      return [];
    }
  }

  const palavras = palavrasDoNome(texto);
  if (!palavras.length) return null;
  const maior = palavras.reduce((a, b) => (b.length > a.length ? b : a));
  const { data } = await axios.get(`${API_BASE_URL}/clientes/nome/${encodeURIComponent(maior.toLowerCase())}`, auth());
  return (Array.isArray(data) ? data : []).filter((c) => nomeConfere(c.nome, palavras));
}
